import React from "react";
import { useSelector } from "react-redux";
import Summary from "../../../../components/cases/assets/balanceOfAssets/corporateShareholding/Summary";

const CorporateShareholdings = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <Summary next={next} back={back} updates={updates} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="CoShareholdings"
        setVisited={visited}
      /> */}
    </>
  );
};

export default CorporateShareholdings;
